// extracted by mini-css-extract-plugin
module.exports = {"Projects":"Projects_Projects__VJ48J","grid":"Projects_grid__pXyJr","item":"Projects_item__nSP67","col2":"Projects_col2__hRkpu","col3":"Projects_col3__3G1K3"};